import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';

export default function FaqPreview() {
  const shown = faqs.slice(0, 3);
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="container-site">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-start">
          <div>
            <span className="inline-block rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl">读者最关心的问题</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
              关于作品剧情、核心设定、人物关系与更新节奏，这里整理了读者最常问的几个问题。
              如果还有疑问，欢迎进入完整问答页查看。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              查看全部问答
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="space-y-4">
            {shown.map((item, idx) => (
              <div
                key={item.q}
                className="rounded-lg border border-background-200 bg-background-100 p-6"
              >
                <div className="flex items-start gap-3">
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-background-50 ${
                      idx === 0 ? 'bg-primary-500' : idx === 1 ? 'bg-accent-500' : 'bg-secondary-500'
                    }`}
                  >
                    <i className="ri-question-line text-sm" />
                  </span>
                  <h3 className="pt-1 text-base font-semibold text-foreground-950">{item.q}</h3>
                </div>
                <p className="mt-3 pl-11 text-sm leading-7 text-foreground-700">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}